// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","primary":"Button_primary__9MLUH","secondary":"Button_secondary__sUGsj","withoutStyle":"Button_withoutStyle__RpmCQ","disabled":"Button_disabled__DkgJ+"};